import { render, staticRenderFns } from "./goodsListByCourse.vue?vue&type=template&id=e1b3cc9c&scoped=true"
import script from "./goodsListByCourse.vue?vue&type=script&lang=js"
export * from "./goodsListByCourse.vue?vue&type=script&lang=js"
import style0 from "./goodsListByCourse.vue?vue&type=style&index=0&id=e1b3cc9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1b3cc9c",
  null
  
)

export default component.exports